import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  linkList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: 0,
    margin: 0,
    listStyleType: 'none',
  },
  link: {
    '&:not(:last-child)': {
      '&::after': {
        content: '"|"',
        margin: '0 3px',
      },
    },
  },
});

export default useStyles;
